/** @jsx jsx */
import { css, jsx } from '@compiled/react';
import AvatarDI from '@atlaskit/avatar';
import AddonIconDI from '@atlaskit/icon/glyph/addon';
import {
	EnvironmentLozenge as EnvironmentLozengeDI,
	nameWithCustomEnvironment,
} from '@atlassian/jira-forge-ui-extension-title/src/ui/environment-lozenge/index.tsx';
import { CustomHeader as HeaderDI } from '../../common/ui/custom-header/index.tsx';
import type { ForgePageHeaderProps } from './types.tsx';

const containerNestedStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingLeft: '21px',
});

export const ForgePageHeader = ({
	Avatar = AvatarDI,
	// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
	AddonIcon = AddonIconDI,
	Header = HeaderDI,
	EnvironmentLozenge = EnvironmentLozengeDI,
	avatarUrl,
	environmentType,
	environmentKey,
	name,
	nestedMenuActive,
}: ForgePageHeaderProps) => {
	return (
		<Header
			iconBefore={
				avatarUrl?.length ? (
					<Avatar
						appearance="square"
						borderColor="transparent"
						size="small"
						src={`${avatarUrl}?size=xxlarge`}
					/>
				) : (
					<AddonIcon label="" size="medium" />
				)
			}
			iconAfter={<EnvironmentLozenge environmentType={environmentType} />}
			css={nestedMenuActive && containerNestedStyles}
		>
			{nameWithCustomEnvironment(name, environmentType, environmentKey)}
		</Header>
	);
};
